import { useEffect, useState, useMemo } from 'react';
import { UserInfoPayload } from '../types';

export const useUserInfo = (identityApiUrl: string | undefined): UserInfoPayload | undefined => {
  const [userInfo, setUserInfo] = useState<UserInfoPayload | undefined>();

  useEffect(() => {
    if (identityApiUrl === undefined) {
      setUserInfo(undefined);
      return;
    }

    const fetchUserInfo = async () => {
      await fetch(identityApiUrl, {
        credentials: 'include',
      })
        .then(async userInfoRes => {
          // Set userInfo if fetch succeeds and status code is 200
          if (userInfoRes.status === 200) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const resUserInfo: UserInfoPayload | undefined = await userInfoRes.json();

            setUserInfo(resUserInfo);
          }
        })
        .catch(() => setUserInfo(undefined)); // Set userInfo as undefined if fetch fails
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchUserInfo();
  }, [identityApiUrl]);

  return userInfo;
};
